import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImageCollection } from 'src/models/DTO/image/imageCollection';
import { DeleteImage } from 'src/models/requestModels/images/DeleteImage';
import { CreateNewBase64Image } from 'src/models/requestModels/images/Image';
import { Config } from '../../../infrastructure/config';
import { Image } from '../../../models/DTO/image/image';

@Injectable({
  providedIn: 'root'
})
export class ImagesService {


  private imageURL : string = Config.api + "media";


  private getUserImageURL : string = Config.api + "api/images";
  private createUserImageURL : string = Config.api + "api/images";
  private updateUserImageURL : string = Config.api + "api/images";
  private getProductsImagesURL : string = Config.api + "api/images";
  private getPartnerImagesURL : string = Config.api + "api/images";
  private getVariationsImagesUrl: string = Config.api + 'api/images'

  constructor(private httpClient: HttpClient) {
  }


  getImagesForProduct(type: string, itemUUID: string, collection: string = 'images') {
    const queryParam = '/' + [type, itemUUID, collection].join('/');
    return this.httpClient.get<ImageCollection>(this.imageURL + queryParam);
  }


  createNewImage(newImageModel: CreateNewBase64Image) {
    return this.httpClient.post<Image>(this.imageURL, newImageModel);
  }

  getImagesPerProduct(type: string, itemUUID: string, collection: string = 'images') {
    const queryParam = '/' + [type, itemUUID, collection].join('/');
    return this.httpClient.get<ImageCollection>(this.imageURL + queryParam);
  }

  deleteImage(imageToDelete: DeleteImage) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: imageToDelete
    }
    return this.httpClient.delete<any>(this.imageURL, options)
  }
}
